import { navTopics } from "@/mocks/jiukanliao";

const COLUMNS = [
  { title: "内容板块", links: ["九宫格热榜", "九图吃瓜精选", "截图合集", "多图预警", "图文猛料"] },
  { title: "浏览指南", links: ["看图指南", "常见问题", "追更提醒", "题材目录", "编辑部专栏"] },
];

export default function Footer() {
  return (
    <footer className="bg-[#f6ecd8]">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-[#ff7a45] to-[#d9431f]">
                <i className="ri-image-2-line text-lg text-white" />
              </span>
              <span className="font-display text-2xl font-black text-[#231f18]">9看料</span>
            </a>
            <p className="mt-4 max-w-sm text-[13px] leading-6 text-[#6b5f48]">
              9看料 九宫格爆料图集，汇总图片爆料、截图合集与九图吃瓜内容。多图预警的图文猛料，按时间轴整理，方便快速锁定关键截图与现场细节。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["九宫格", "九图吃瓜", "图片爆料", "截图合集", "多图预警", "图文猛料"].map((k) => (
                <span
                  key={k}
                  className="rounded-full border border-[#e0cda4] px-2.5 py-1 text-[11px] text-[#7a5c2e]"
                >
                  {k}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="text-sm font-semibold text-[#231f18]">热门题材</p>
            <div className="mt-4 flex flex-wrap gap-x-5 gap-y-3">
              {navTopics.map((t) => (
                <a
                  key={t.id}
                  href="#topics"
                  className="text-[13px] text-[#6b5f48] transition hover:text-[#b43a17]"
                >
                  {t.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm font-semibold text-[#231f18]">快速入口</p>
            <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {COLUMNS.map((c) =>
                c.links.map((l) => (
                  <a
                    key={l}
                    href="#home"
                    className="text-[13px] text-[#6b5f48] transition hover:text-[#b43a17]"
                  >
                    {l}
                  </a>
                ))
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-[#e0cda4] pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[11px] leading-5 text-[#9a7f52]">
            本站仅作娱乐图文信息的可视化整理与呈现，内容观点不代表本站立场。理性围观、友善发言。图片为示意内容。
          </p>
          <p className="whitespace-nowrap text-[11px] text-[#9a7f52]">
            © 2026 9看料 · 九宫格 · 九图 · 猛料
          </p>
        </div>
      </div>
    </footer>
  );
}